import prisma from "@/lib/prisma-client";
import { enhance } from "@zenstackhq/runtime";
import type { Session } from "next-auth";

export default class Utils {
  static normalizeName(name: string) {
    const slug = name
      .trim()
      .toLowerCase()
      .replace(/&/g, "-and-")
      .replace(/[\s\/:\\"\.-]+/g, "-")
      .replace(/[\'\"`‘’“”~!@#$%^&*()+=<>?;:,{}\[\]\\\/|]/g, "-") // 特殊文字をハイフンに置換
      .replace(/[^-\w\u0080-\uFFFF]/g, "") // ASCII範囲外および単語文字、ハイフンを除くすべての文字を削除
      .replace(/-+/g, "-") // 連続するハイフンを一つに置換
      .replace(/^-+|-+$/g, ""); // 先頭最後のハイフンを削除
    return slug;
  }

  static async makeSlug(table: "list" | "spot", normalizedName: string) {
    let slug: string;

    const lastSameName =
      table === "list"
        ? await prisma.list.findFirst({
            where: { normalizedName: normalizedName },
            orderBy: { slug: "desc" },
          })
        : await prisma.spot.findFirst({
            where: { normalizedName: normalizedName },
            orderBy: { slug: "desc" },
          });

    if (lastSameName) {
      const lastUsedSlug = lastSameName.slug;
      const number = Number(lastUsedSlug.split("-").pop());
      if (number) {
        slug = `${normalizedName}-${number + 1}`;
      } else {
        slug = `${normalizedName}-2`;
      }
    } else {
      slug = normalizedName;
    }
    return slug;
  }

  static async sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  static async enhancedPrisma(session: Session | null) {
    if (!session || session?.user?.id) {
      const user = await prisma.user.findFirstOrThrow({ where: { id: session?.user?.id } });
      return enhance(prisma, { user: user });
    } else {
      return enhance(prisma, {});
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static arrayUnique(x: Array<any>) {
    return x.filter((v, i) => x.indexOf(v) === i);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static arrayUniqueRecord(x: Array<any>) {
    return x.filter((v, i) => x.findIndex((z) => z.id === v.id) === i);
  }

  static calcBounds({ places }: { places: { lat: number; lng: number }[] }) {
    if (places.length === 0) {
      return null;
    }

    const bounds = {
      ne: { lat: -90, lng: -180 },
      sw: { lat: 90, lng: 180 },
    };
    places.forEach((place) => {
      bounds.ne.lat = Math.max(bounds.ne.lat, place.lat);
      bounds.ne.lng = Math.max(bounds.ne.lng, place.lng);
      bounds.sw.lat = Math.min(bounds.sw.lat, place.lat);
      bounds.sw.lng = Math.min(bounds.sw.lng, place.lng);
    });
    return bounds;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static shortAddressFromGoogleAddressComponents(addressComponents: any) {
    {
      if (addressComponents) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const prefecture = addressComponents.find((x: any) =>
          x.types.includes("administrative_area_level_1"),
        )?.long_name;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const town = addressComponents.find((x: any) => x.types.includes("locality"))?.long_name;

        if (prefecture && town) {
          return `${town}, ${prefecture}`;
        }
      }

      return null;
    }
  }
}
